export const MANAGMENT_NOTIFICATION_TYPES = {
  NO_DATA_AVAILABLE: 'NO_DATA_AVAILABLE',
};
